<div [innerHTML]="style"></div>
<div class="expand-cta-btn">
  <a [attr.href]="userVideo.ctaSimple.linkUrl" [class.show]="userVideo.ctaSimple.isShown" (click)="ctaSimpleCtaClicked()" target="_blank">
    <div class="expand-cta-btn-container">
      <span class="expand-cta-btn-text">{{userVideo.ctaSimple.title}}</span>
      <span class="material-icons">chevron_right</span>
    </div>
  </a>
</div>